import {SECTION_TO_INPUT_FIELDS} from '../constants/section-to-input-fields'
import {SECTION_MAP} from '../constants/section-mapping'

export const getInputFieldsConfigBySection = (sectionName: string): string[] => {
  const inputFields: string[] = []
  if (typeof SECTION_MAP[sectionName] !== 'undefined') {
    SECTION_MAP[sectionName].forEach((subSectionName: string) => {
      inputFields.push(...getInputFieldsConfigBySection(subSectionName))
    })
  }

  if (typeof SECTION_TO_INPUT_FIELDS[sectionName] !== 'undefined') {
    inputFields.push(...SECTION_TO_INPUT_FIELDS[sectionName])
  }

  return inputFields
}

export const getSubSectionsBySection = (sectionName: string, recursive = false): string[] => {
  if (typeof SECTION_MAP[sectionName] !== 'undefined') {
    const subSections = SECTION_MAP[sectionName]

    if (recursive) {
      return [
        ...subSections,
        ...subSections.flatMap(subSection => getSubSectionsBySection(subSection, true)),
      ]
    }
    return subSections
  }
  return []
}
